import React, { FC } from 'react';
import { Divider, StackProps } from '@mui/material';

import { Stack, Box, Typography, useMobile, useDesktop } from 'Modules/ui3';


interface StepProps {
    number: string;
    text: React.ReactNode;
    last?: boolean;
}

type NumberedStepsProps = StackProps & {
    steps: StepProps['text'][];
}

const Step: FC<StepProps> = ({ number, text, last }) => {
    const isDesktop = useDesktop();
    const isMobile = useMobile();
    return (
        <Stack flex={1}>
            <Stack direction='row' alignItems='center'>
                <Typography
                    variant={isDesktop ? 'mediumBody2' : 'mediumCaption2'}
                    lineHeight={isDesktop ? '1.5' : '1.4'}
                    bgcolor='grayscale.shade0'
                    border='1px solid'
                    borderColor='grayscale.shade95'
                    borderRadius={2}
                    py={1}
                    px={4}
                    flex='0 0 auto'
                >
                    {number}
                </Typography>
                {!isMobile && !last && <Divider sx={{ width: '100%' }} />}
            </Stack>
            <Box
                flex={1}
                mt={isDesktop ? 5 : 1}
                p={isDesktop ? 6 : 3}
                border='1px solid'
                borderColor='grayscale.shade40'
                borderRadius={`${isDesktop ? '8px' : '20px'} 20px 20px 20px`}
            >
                <Typography component='p' variant={isDesktop ? 'regularBody2' : 'regularCaption3'} lineHeight={isDesktop ? '1.5' : '1.4'} color='grayscale.shade95'>
                    {text}
                </Typography>
            </Box>
        </Stack>
    );
};

export const NumberedSteps: FC<NumberedStepsProps> = ({ steps, ...props }) => {
    const isMobile = useMobile();
    return (
        <Stack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 4 : 2} {...props}>
            {steps.map((step, idx) => <Step key={`step_${idx}`} number={`Шаг ${idx + 1}`} text={step} last={idx === steps.length - 1} />)}
        </Stack>
    );
};
